module.exports = __webpack_public_path__ + "media/images/home/mini/6-3806b3b17180288ea32ce0e31dbad37a.png";